import { createVNode as l, mergeProps as m } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/DocumentFilled.js";
import n from "../components/PfIcon.js";
const e = (t, o) => {
  const r = {
    ...t,
    ...o.attrs
  };
  return l(n, m(r, {
    icon: i
  }), null);
};
e.displayName = "DocumentFilled";
e.inheritAttrs = !1;
export {
  e as default
};
